import { Tooltip } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";

function Sidedrawitem({ hidden, href, isActive, children, onClick, title }) {
  return onClick ? (
    <li hidden={hidden} title={title} onClick={onClick}>
      <Tooltip title={title} placement="right">
        <Link>{children}</Link>
      </Tooltip>
    </li>
  ) : (
    <li hidden={hidden} title={title}>
      <Tooltip title={title} placement="right">
        <Link to={href}>{children}</Link>
      </Tooltip>
    </li>
  );
}

export default Sidedrawitem;
